<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import Qs from 'qs'
  import URL from '@/api/im/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  let type = {1:"通话标题",2:"分机",4:"拨打线路"}
  let userList = {};
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    mounted() {
      this.axios.post(URL.call.customer.getServiceUser,  {pageNum: 1, pageSize: 1000},{headers:{'Content-Type': 'application/json'}}).then(res => {
        //console.log(res);
        if (res.code == 0 && res.result){
          let arr = res.result.list;
          for (let i in arr) {
            userList[arr[i].userName] = arr[i].displayName;
          }
        }
      })
    },
    methods: {
      checkbox(row){
        this.deleteIds = row.map(key => key.id).join(",");
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          this.$refs.childUpdate.open(row);
        }else if (clickName == "delete"){
          this.dataChanage(URL.call.setting.del,{id:row.id},res => {
            this.$refs.childTable.defaultGetData(this.queryData);
            if (res.code == 0){
              this.$refs.childUpdate.close();
              this.$message.success("suc");
            }else{
              this.$message.error(res.message);
            }
          })
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(this.queryData);
        }else if("新增" == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        this.dataChanage(URL.call.setting.edit,model,res => {
          this.$refs.childTable.defaultGetData(this.queryData);
          if (res.code == 0){
            this.$refs.childUpdate.close();
            this.$message.success("suc");
          }else{
            this.$message.error(res.message);
          }
        })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
            { title: '主键', field: 'id',hidden:true},
            { title: '公司id', field: 'companyId',hidden:true},
            { title: '业务组', field: 'businessType',hidden:true},
            { title: '类型', field: 'type',type:2,optionList:type,isNumber:true,required:true},
            { title: '内容', field: 'content',required:true},
            { title: '备注', field: 'remark'},
            { title: '客服', field: 'user',type:2,optionList:userList,hidden: (model,col)=>{
                return model.type != 2;
              },required: (model,col)=>{
                return model.type == 2;
              }},
          ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              {click:"查询"},
              {click:"新增"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.call.setting.list, //请求路径和参数
          sequence: true,
          isPage:false,
          cols: [
              { title: '主键', field: 'id'},
              { title: '公司id', field: 'companyId'},
              { title: '业务组', field: 'businessType'},
              { title: '类型', field: 'type',render:(data,full)=>{
                  return type[data];
                }},
              { title: '内容', field: 'content'},
              { title: '备注', field: 'remark'},
              { title: '创建人', field: 'creator'},
              { title: '创建时间', field: 'createTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},
              { title: '更新人', field: 'updater'},
              { title: '修改时间', field: 'updateTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},
            {title: '操作',width: 200,btnClick:[
                {name: '修改',click:"update",type:"primary",icon:"el-icon-edit"},
                {name: '删除',click:"delete",type:"primary",icon:"el-icon-delete"},
              ]
            },
          ]
        }
      }
    }
  }
</script>
